export const scrollToMap = async () => {
  const clickLocationAccordion = () => {
    const btn = document.querySelector('.location-accordion') as any
    btn.click()
  }
  const findMap = () => document.querySelector('.google-maps')
  let map = findMap()
  if (map && map.getBoundingClientRect().width === 0) {
    clickLocationAccordion()
  }
  setTimeout(() => {
    map = findMap()
    map?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  })
}
